export const LAST_DOCUMENTS_DOWNLOAD_KEY = `last-documents-download`;
